import { render, staticRenderFns } from "./RobotQuickEducation.vue?vue&type=template&id=13768876&scoped=true"
import script from "./RobotQuickEducation.vue?vue&type=script&lang=js"
export * from "./RobotQuickEducation.vue?vue&type=script&lang=js"
import style0 from "./RobotQuickEducation.vue?vue&type=style&index=0&id=13768876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13768876",
  null
  
)

export default component.exports